import { render } from "./PageA.vue?vue&type=template&id=784233ba&scoped=true"
import script from "./PageA.vue?vue&type=script&lang=js"
export * from "./PageA.vue?vue&type=script&lang=js"

import "./PageA.vue?vue&type=style&index=0&id=784233ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784233ba"]])

export default __exports__